import Pica from 'pica';

/**
 * Feature set every caller shares: WebAssembly resizing inside web workers.
 * Part of the singleton key — Pica only dedupes its internal worker pool for
 * instances created with identical options.
 */
const PICA_FEATURES: ['wasm', 'ww'] = ['wasm', 'ww'];

let instance: ReturnType<typeof Pica> | null = null;

/**
 * Shared Pica instance for the whole app.
 *
 * Every `Pica()` permanently allocates resources that are never released:
 * its own `WebAssembly.Memory` plus compiled wasm modules, a feature-probe
 * web worker that is created without ever being terminated, and a worker
 * blob URL that is never revoked. Constructing one per image therefore leaks
 * proportionally to the batch size — which is exactly what happened in the
 * creator and ad manager upload loops.
 *
 * Pica is stateless between `resize()` calls, so one instance can serve the
 * whole session. It is created lazily so that importing this module does not
 * spin up workers or compile wasm in code paths that never resize anything.
 */
export const getPica = () => {
  if (!instance) {
    instance = Pica({ features: PICA_FEATURES });
  }
  return instance;
};
